<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <span style="font-weight:500">Tìm kiếm đại lý</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0"
                outlined
        >
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
              <v-row>
                <v-col
                    cols="6"
                    md="6"
                >
                  <v-text-field
                          v-model="filterForm.name"
                          label="Tìm kiếm theo tên đại lý"
                          placeholder="Đại lý..."
                          style="font-weight:500"
                          clearable
                          @keyup.enter="searchAgency"
                  />
                </v-col>

                <v-col
                    cols="6"
                    md="6"
                >
                  <v-text-field
                          v-model="filterForm.phone"
                          label="Tìm kiếm theo sđt đại lý"
                          placeholder="Số điện thoại..."
                          style="font-weight:500"
                          clearable
                          @keyup.enter="searchAgency"
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn
                        class="primary mx-0"
                        @click="searchAgency"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>

            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  export default {
    name: 'FilterForm',
    props: {
      filterForm: {
        default: () => ({}),
      },
    },
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
      searchAgency () {
        if (this.filterForm.name !== undefined
          && this.filterForm.name !== null
          && this.filterForm.name !== '') {
          this.filterForm.name = this.filterForm.name.trim()
        }
        if (this.filterForm.phone !== undefined
          && this.filterForm.phone !== null
          && this.filterForm.phone !== '') {
          this.filterForm.phone = this.filterForm.phone.trim()
        }
        Bus.$emit('agency-list-filter', this.filterForm)
      },
    },
  }
</script>
